/* eslint-disable no-nested-ternary */
import React from 'react';
import { AdditionalStyles } from 'types/common/AdditionalStyles';
import CapitalizeFirstLetter from '_helpers/generic/CapitalizeFirstLetter';
import Paragraph from '../paragraph';
import Subtitle from '../subtitle';

interface Props extends AdditionalStyles {
  items: Object;
}

export default function List({ items, styles }: Props) {
  return (
    <div className={`${styles}`}>
      {Object.entries(items).map(
        ([k, v]) =>
          v && (
            <div key={k} className="flex flex-col sm:flex-row text-start">
              <Subtitle text={`${CapitalizeFirstLetter(k)}:`} styles="font-medium mr-0 sm:mr-2 " />
              {Array.isArray(v) ? (
                <div className="flex flex-row">
                  {v.map((e: string, i) => (
                    <Paragraph key={e} text={`${e}${i === v.length - 1 ? '' : ','}`} styles="mb-2 sm:mb-0 mr-1" />
                  ))}
                </div>
              ) : k === 'phone' ? (
                <a href={`tel:${v?.replace(/\s/g, '')}`}>
                  <Paragraph text={v} styles="mb-2 sm:mb-0" />
                </a>
              ) : k === 'email' ? (
                <a href={`mailto:${v?.replace(/\s/g, '')}`}>
                  <Paragraph text={v} styles="mb-2 sm:mb-0" />
                </a>
              ) : (
                <Paragraph text={v} styles="mb-2 sm:mb-0" />
              )}
            </div>
          ),
      )}
    </div>
  );
}
